import { Modal, Form, Button } from "semantic-ui-react";
import useForm from "../../../hooks/useForm";

function AjustaNomeModal({ onChangeNomes, isOpen, setIsOpen, nomeInicial }) {
  const nextWithValidation = () => {
    onChangeNomes({
      "nomeSocial": data.nomeSocial,
      "nomeRegistro": data.nomeRegistro
    })
    setIsOpen(false);
  };

  const validations = {
    nomeSocial: {
      required: {
        value: true,
        message: "Informe seu nome completo",
      },
      custom: {
        isValid: (value) => /^[a-zA-ZáéíóúÁÉÍÓÚâêîôûÂÊÎÔÛãõñçÇ ]+$/.test(value),
        message: "Nome deve conter apenas letras",
      },
    },
    nomeRegistro: {
      required: {
        value: true,
        message: "Informe seu nome completo",
      },
      custom: {
        isValid: (value) => /^[a-zA-ZáéíóúÁÉÍÓÚâêîôûÂÊÎÔÛãõñçÇ ]+$/.test(value),
        message: "Nome deve conter apenas letras",
      },
    },
  };

  const { data, handleChange, handleSubmit, handleBlur, errors } = useForm(
    validations,
    {
      nomeSocial: nomeInicial,
      nomeRegistro: nomeInicial,
    },
    nextWithValidation
  );

  return (
    <Modal open={isOpen}>
      <Modal.Content>
        <Form>
          <p style={{ fontSize: "1.25rem" }}>
            Vamos precisar que você verifique se seu cadastro está correto:
          </p>
          <Form.Group widths="equal">
            <Form.Input
              fluid
              id="nomeSocial"
              name="nomeSocial"
              required
              defaultValue={data.nomeSocial}
              label="Seu nome"
              onBlur={handleBlur}
              error={!!errors.nomeSocial}
              onChange={(e, data) => handleChange("nomeSocial", data.value)}
              maxLength={100}
            />
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Input
              fluid
              id="nomeRegistro"
              name="nomeRegistro"
              required
              defaultValue={data.nomeRegistro}
              label="Nome que consta nos seus documentos"
              onBlur={handleBlur}
              error={!!errors.nomeRegistro}
              onChange={(e, data) => handleChange("nomeRegistro", data.value)}
              maxLength={100}
            />
          </Form.Group>

          <Button onClick={handleSubmit} primary>
            Confirmar
          </Button>
        </Form>
      </Modal.Content>
    </Modal>
  );
}

export default AjustaNomeModal;
